<template>
  <div
    class="wrapper-base-notification-bell"
    @click="handleClick">
    <a class="btn no-bg">
      <i class="fas fa-bell" />
    </a>
    <span
      v-if="count > 0"
      class="count">
      {{ count }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    count: Number,
  },

  methods: {
    handleClick() {
      this.$emit('onClick')
    },
  },
}
</script>

<style scoped>
.wrapper-base-notification-bell {
  position: relative;
}

i.fa-bell {
  color: #fff;
  font-size: 18px;
  position: relative;
  top: 2px;
}

.count {
  width: 18px;
  height: 18px;
  position: absolute;
  z-index: 1;
  top: 0;
  right: 5px;
  border-radius: 100%;
  background: #dc3545;
  color: #fff;
  font-size: 9px;
  text-align: center;
  line-height: 19px;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseNotificationBell.vue